import React from "react";
// import Botdetail from "../../botDetailEndUser/index";
import { connect } from "react-redux";
import { useRouter } from 'next/router'
import styles from "../../../styles/pages/botStore.module.scss";
import { imageBaseURL } from "../../../data/createBotForm";


function index(props) {


  const router = useRouter()

  const [currentBot, setCurrentBot] = React.useState(null)





  React.useEffect(() => {
    setCurrentBot(props.currentBot)
  }, [props.currentBot])



  React.useEffect(() => {
    console.log(router.query, "all kinda queries")
  }, [router.query])



  return (
    <div>
       <div className="container h-100">
        <div className="row  mt-5">
            <div className="col-md-6 col-12">
                <div className={styles.crard_main_section}>
                    <div className="d-flex align-items-center mb-3 mt-4">
                    <img src={`${imageBaseURL}product5.svg`} alt=""  className="mr-2"/><h1 style={{fontWeight:"600"}}>Share on Shelf</h1>
                    </div>
                    <div className={styles.card_section1}>
                        <div className="mb-3">
                            <img src={`${imageBaseURL}maps.svg`} alt="" className="mr-2" />
                            <span>Clusters Live</span>
                        </div>
                        <p>South Asia (India), LATAM (Argentina)</p>
                    </div>
                    <p className="crard_main_section_p">Now we have Image Analytics to detect SKUs on Shelf & use that information to recommend order to the salesmen</p>
                </div>
                <div className={`${styles.blue_card_section} col-12 col-md-6`}>  
                <div class="justify-content-center">
                <h1>55,000</h1>
                            <p>Manhours saved</p>
                </div>
                </div>
            </div>
            <div className="col-md-6 col-12">
                 <div className={styles.iframe_section} dangerouslySetInnerHTML={{ __html: `<iframe src=${imageBaseURL}share.mp4 paused/>`}} />
            </div>
        </div>
       </div>
       <div className={styles.benefits_section}>
            <div className="container h-100">
                <div  className="mb-5">
                <h1>Benefits</h1>
                </div>
                <div className={styles.Frist_section}>
                <div className="row ">
                    <div className="col-md-3 col-6  mb-4 mb-md-0">
                        <div className={styles.cards_benefits}>
                            <img src={`${imageBaseURL}benefits8.svg`} alt="" />
                            <p>Time savings for Salesmen and retailers</p>
                        </div>
                    </div>
                    <div className="col-md-3 col-6 mb-4 mb-md-0">
                        <div className={styles.cards_benefits}>
                            <img src={`${imageBaseURL}benefits9.svg`} alt="" />
                            <p>Efficient Sales call</p>
                        </div>
                    </div>
                    
                </div>
                </div>
                <div className="row">
                    <div className="col-md-6 ">
                        <div  className={`text-center position-relative ${styles.cards_benefits_card}`}>
                         <img src={`${imageBaseURL}robo.png`} alt="" />
                            <div className="back_image">
                                <img src={`${imageBaseURL}dot.svg`} className={styles.img_1} alt="" />
                                <img src={`${imageBaseURL}dot1.svg`} className={styles.img_2} alt="" />
                                <img src={`${imageBaseURL}dot2.svg`} className={styles.img_3} alt="" />

                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <h2 className="mb-5" style={{fontWeight:"600"}}>Process</h2>
                        {/* <p className="mb-4">1,000s of invoices left to be updated! Don’t worry, we can help your team colate & update invoices on your behalf.</p> */}
                        <ol>
                            <li >
                                <div>
                                    <p>Salesmen clicks the shelf photographs in his<br/> HHT and then the image is sent for processing</p>
                                </div>
                            </li>
                            <li >
                                    <div>
                                        <p>
                                        Model runs on the image that is clicked and is<br></br> trained for all competitor brands as well 
                                        </p>
                                    </div>
                                </li>
                            <li >
                                <div>
                                    <p>The solution provides recommendation on <br/> what order needs to be taken</p>
                                </div>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default index;

